var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CRow',[_c('CCol',{attrs:{"md":"12"}},[_c('h3',{staticClass:"text-gray text-center f-weight-700"},[_vm._v(" Task 2: The second step ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }